'use client';
import styled from 'styled-components';

export default styled.circle`
  fill: white;
  r: 5px;
  stroke: ${props => props.color};
  stroke-width: 2px;
`;
